export * from "./lib/registry-redirect/registry-redirect.component";
export * from "./lib/registry-redirect.service";
export * from "./lib/shared-feature-redirect.module";
